import { render, staticRenderFns } from "./SyncDataDialog.vue?vue&type=template&id=12f6d0b5&scoped=true&"
import script from "./SyncDataDialog.vue?vue&type=script&lang=js&"
export * from "./SyncDataDialog.vue?vue&type=script&lang=js&"
import style0 from "./SyncDataDialog.vue?vue&type=style&index=0&id=12f6d0b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f6d0b5",
  null
  
)

export default component.exports